import { MasonryHeroBannerRenderer } from '@leagueplatform/masonry-renderers';
import { styled } from '@leagueplatform/genesis-core';

const StyledMyHealthHeroBanner = styled(MasonryHeroBannerRenderer, {
  '@mobile': {
    '&&::before': {
      height: '5030px',
      borderRadius: '5030px',
    },
  },
});

export const MyHealthHeroBanner: typeof MasonryHeroBannerRenderer = (
  { css, ...props }, // eslint-disable-line react/prop-types
) => (
  <StyledMyHealthHeroBanner
    {...props}
    css={{
      ...css,
      '& .GDS-button': {
        marginTop: '$none',
      },
      '& .GDS-paragraph-text': {
        marginBlockEnd: '$threeQuarters',
      },
    }}
  />
);
